import { css } from 'styled-components';

const BrowserButton = css`
  background-color: inherit;
  border: 0;
  border-radius: 0;
  color: inherit;
  font-size: inherit;
  margin: 0;
  outline: none;
  padding: 0;
  text-align: unset;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
`;

const BrowserAnchor = css`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;

const BrowserSelect = css`
  /* Firefox */
  -moz-appearance: none;

  &:-moz-focusring {
    text-shadow: 0 0 0 $color-black;
  }

  /* Webkit */
  -webkit-appearance: none;

  /* IE 11+ */
  &::-ms-expand {
    display: none;
  }
`;

const BrowserInput = css`
  padding: 1px 0;
`;

export default { BrowserButton, BrowserAnchor, BrowserSelect, BrowserInput };
